/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export const SET_VIDEO_PLAYER_STATE = 'SET_VIDEO_PLAYER_STATE';
